import Login from "./../views/Login.vue";

 import { routes as administrativeRoutes } from "./administrative";
 import { routes as administratorRoutes } from "./administrator";
 import { routes as directiveRoutes } from "./directive";

export const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    name: "login",
    component: Login,
  },
  ...administrativeRoutes,
  ...administratorRoutes,
  ...directiveRoutes,
  {
    path:'*',
    redirect:'/'
  }
];
